import React, { useState } from 'react';

import css from './VerifyFunding.module.scss';
import Message from '../../components/UI/Message';
import Cleave from '../../components/UI/Input/Cleave';
import Button from '../../components/UI/Button';

interface Props {
  loading?: boolean;
  error?: boolean;
  message?: boolean;
  fundingAccounts: {
    message?: string;
  };
  onClickVerifyLater: () => void;
  onClickVerifyNow: (amount1: Amount, amount2: Amount) => void;
}

type Amount = string | undefined;

const VerifyMicrodeposits = (props: Props) => {
  const [showHelpText, setShowHelpText] = useState(false);
  const [amount1, setAmount1] = useState<Amount>();
  const [amount2, setAmount2] = useState<Amount>();

  return (
    <>
      <h1 data-e2e="verify-trial-withdrawals-header">Verify your card now.</h1>
      <h2 data-e2e="verify-trial-withdrawals-subheader">
        Safety first. And second. And third.
      </h2>
      <Message error={props.error} text={props.message} />

      <div className={css.VerifyFundingMessage}>
        {props.fundingAccounts.message}
      </div>

      <div className={css.VerifyFundingForm}>
        <div className={css.verifyInputs}>
          <Cleave
            id="amount-1"
            options={{
              prefix: '$ ',
              rawValueTrimPrefix: true,
              numeral: true,
              numeralThousandsGroupStyle: 'thousand',
              numeralDecimalScale: 2,
              numeralPositiveOnly: true
            }}
            inputMode="text"
            max="1000"
            pattern="[0-9\.]*"
            rawValue={true}
            onChange={(amt: string) => setAmount1(amt.replace(',', '.'))}
            data-e2e="verify-1"
            data-testid="amount-1"
          />
          <Cleave
            id="amount-2"
            options={{
              prefix: '$ ',
              rawValueTrimPrefix: true,
              numeral: true,
              numeralThousandsGroupStyle: 'thousand',
              numeralDecimalScale: 2,
              numeralPositiveOnly: true
            }}
            inputMode="text"
            max="1000"
            pattern="[0-9\.]*"
            rawValue={true}
            onChange={(amt: string) => setAmount2(amt.replace(',', '.'))}
            data-e2e="verify-2"
            data-testid="amount-2"
          />
        </div>
        <div className={css.buttonContainer}>
          <Button
            text="Verify Later"
            loading={props.loading}
            secondary={true}
            onClick={props.onClickVerifyLater}
            data-e2e="btn-verify-later"
          />
          <Button
            text="Verify This Card Now"
            loading={props.loading}
            onClick={() => props.onClickVerifyNow(amount1, amount2)}
            data-e2e="btn-verify-now"
          />
        </div>

        <a
          onClick={e => {
            e.preventDefault();
            setShowHelpText(true);
          }}
        >
          Help! I can't find the transactions.
        </a>

        {showHelpText && (
          <>
            <p>
              Some banks don't show pending transactions in their online banking
              website or mobile app.
            </p>
            <p>
              If your bank doesn't show pending transactions, please call your
              bank (the number should be on the back of your debit card) and ask
              them to tell you the amounts of the 2 pending transactions from
              Greenlight.
            </p>
          </>
        )}
      </div>
    </>
  );
};

export default VerifyMicrodeposits;
